// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"590":"87dbeef0","703":"e0658e55"}[chunkId] + ".chunk.js";
};